export default {
  LOADING: 'CONTROL_VIEW_CONTROL_PANEL_LOADING',
  LOADED: 'CONTROL_VIEW_CONTROL_PANEL_LOADED',
};
